import { IApproval, IApprovalDetail, ICompliance, ISailPointCertDetails, ITaskDetail } from '@/types/tasksApprovals'

import Default from './layouts/default'
import SailPointCertificates from './layouts/sailPointCertificates'

const Container = ({
    item,
    itemDetails,
    itemId,
}: {
    item: ICompliance | IApproval
    itemDetails: ITaskDetail | IApprovalDetail | ISailPointCertDetails[]
    itemId: string
}) => {
    switch (item.system_id) {
        case 'SAIL_POINT_CERT':
            return <SailPointCertificates item={item} itemDetails={itemDetails as ISailPointCertDetails[]} />
        default:
            return <Default item={item} itemDetails={itemDetails as ITaskDetail | IApprovalDetail} itemId={itemId} />
    }
}

export default Container
